import { useEffect } from 'react'
import { Layout, Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { Header } from './Header'
import { Footer } from './Footer'
import { useCustomisation } from '../context/CustomisationProvider'

const Page = ({ children, title, className = '', layout = '', style = {} }) => {
  const { loading } = useCustomisation()

  useEffect(() => {
    document.title = title
  }, [title])

  return (
    <Layout className={layout + (loading ? ' loading' : '')}>
      <Spin spinning={loading} indicator={<LoadingOutlined spin />}>
        <Header />
        <Layout.Content className={className} style={style}>
          {children}
        </Layout.Content>
        <Footer />
      </Spin>
    </Layout>
  )
}

export default Page
